import React from "react";
import { Form, Input } from "antd";

const AccountVerification = (props) => {
  // -------------------------- VAR --------------------------

  const { disabled } = props;

  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="code"
      rules={[
        {
          required: true,
          message: "Please input verification code",
        },
        {
          min: 6,
          message: "Min length must be at least 6 number",
        },
      ]}
    >
      <Input showCount maxLength={6} placeholder="Verification code" disabled={disabled} />
    </Form.Item>
  );
};

export default AccountVerification;
